export type DimensionedArr<T extends keyof number[], T2 extends any> = { [k in T]: T2 }

export type NestedArray<T, Depth extends number = 1, TT extends unknown[] = []> = Depth extends TT['length'] ? T : NestedArray<T[], Depth, [unknown, ...TT]>

export type ArrayLimitList = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10

export type ArrayLengthLimiter<T extends number[]> = T['length'] extends ArrayLimitList ? T['length'] : 10

export type NestedMap<T> = { [k: string]: T | NestedMap<T> }

export const DailyDecadeBasedArrayDef: DailyDecadeBasedArrayDefType = [10, 12, 31]
export type DailyDecadeBasedArrayDefType = [10, 12, 31]

export const HourlyYearBasedArrayDef: HourlyYearBasedArrayDefType = [12, 31, 24]
export type HourlyYearBasedArrayDefType = [12, 31, 24]

export const QuarterHourYearBasedArrayDef: QuarterHourYearBasedArrayDefType = [12, 31, 24, 4]
export type QuarterHourYearBasedArrayDefType = [12, 31, 24, 4]

export const QuarterHourMonthBasedArrayDef: QuarterHourMonthBasedArrayDefType = [31, 24, 4]
export type QuarterHourMonthBasedArrayDefType = [31, 24, 4]
